export const getUntestedLotMessage = (batchNumber: string | undefined): string =>
  batchNumber ? "Invalid Lot # and Batch #" : "Invalid Lot #"
